export default __webpack_public_path__ + "static/observian-aws-laptop-5d35dad044ccfcc22667f31c255103e5.png";